import { Divider, Stack } from '@mui/material';
import React, { FC, ReactNode } from 'react';

interface InhaltTrennerProps {
	dotted?: boolean;
	marginTop?: string;
	marginBottom?: string;
}
const InhaltTrenner: FC<InhaltTrennerProps> = ({ marginTop = '2rem', dotted, marginBottom }) => {
	return <Divider sx={{ borderColor: '#000', mt: marginTop, mb: marginBottom, borderStyle: dotted ? 'dotted' : 'solid' }} />;
};

interface InhaltWrapperProps {
	marginTop?: string;
	marginBottom?: string;
	children: ReactNode;
}
const InhaltWrapper: FC<InhaltWrapperProps> = ({ marginTop = '2rem', marginBottom = '0', children }) => {
	return (
		<Stack spacing={2} sx={{ mt: marginTop, mb: marginBottom }}>
			{children}
		</Stack>
	);
};

export { InhaltTrenner, InhaltWrapper };
